export class lowercaseValueConverter {
  toView(value: string) {
    return value?.toLowerCase();
  }
}
